import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import {
  ILaneGeographicCriteria,
  ISpotBiddingRule,
  GEOGRAPHIC_CRITERIA_TYPE,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface ILaneGeoValueProps {
  value?: RecursivePartial<ILaneGeographicCriteria>
  onChange: (change: RecursivePartial<ISpotBiddingRule>) => void
  error?: string
}

export const LaneGeoValue = memo<ILaneGeoValueProps>(({ error, onChange, value: laneValue }) => {
  const laneGeographicCriteria = {
    pickupType: GEOGRAPHIC_CRITERIA_TYPE.datMarket,
    pickupValue: undefined,
    deliveryType: GEOGRAPHIC_CRITERIA_TYPE.datMarket,
    deliveryValue: undefined,
    ...laneValue,
  }
  const { deliveryType, deliveryValue, pickupType, pickupValue } = laneGeographicCriteria

  const setPickupLocation = (location: string) => {
    onChange({
      laneGeographicCriteria: {
        ...laneGeographicCriteria,
        pickupValue: location,
      },
    })
  }

  const setDeliveryLocation = (location: string) => {
    onChange({
      laneGeographicCriteria: {
        ...laneGeographicCriteria,
        deliveryValue: location,
      },
    })
  }

  const datMarketPickupHandler = ({
    fullSelection,
  }: {
    value: number
    fullSelection?: { name: string }
  }) => {
    setPickupLocation(fullSelection?.name || '')
  }

  const datMarketDeliveryHandler = ({
    fullSelection,
  }: {
    value: number
    fullSelection?: { name: string }
  }) => {
    setDeliveryLocation(fullSelection?.name || '')
  }

  const placeValue = (criteriaType: GEOGRAPHIC_CRITERIA_TYPE, value?: string) => {
    if (!value) return undefined
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.cityState) {
      const [city, state] = value.split(', ')
      return { city, state }
    }
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.state) {
      return { state: value }
    }
    if (criteriaType === GEOGRAPHIC_CRITERIA_TYPE.datMarket) {
      return { name: value }
    }

    return undefined
  }

  return (
    <>
      {pickupType === GEOGRAPHIC_CRITERIA_TYPE.datMarket && (
        <div className='col-md-6 col-xs-4'>
          <Autocomplete
            id='modal-lane-geo-dat-market-pickup'
            label='Pickup Dat Market'
            value={placeValue(pickupType, pickupValue)?.name}
            type='dat_market'
            onChange={datMarketPickupHandler}
            large
            validationMessage={error}
            dataTest='modal-lane-geo-dat-market-pickup'
          />
        </div>
      )}
      {deliveryType === GEOGRAPHIC_CRITERIA_TYPE.datMarket && (
        <div className='col-md-6 col-xs-4'>
          <Autocomplete
            id='modal-lane-geo-dat-market-delivery'
            label='Delivery Dat Market'
            value={placeValue(deliveryType, deliveryValue)?.name}
            type='dat_market'
            onChange={datMarketDeliveryHandler}
            large
            validationMessage={error}
            dataTest='modal-lane-geo-dat-market-delivery'
          />
        </div>
      )}
    </>
  )
})
